const TYPE_PART_DISPLAYS = {
  snippet: [ { tag: 'p', name: 'text' } ],
  page: [ { tag: 'p', name: 'body' } ],
  email: [
    { tag: 'p', name: 'from' },
    { tag: 'p', name: 'to' },
    { tag: 'p', name: 'cc' },
    { tag: 'p', name: 'bcc' },
    { tag: 'p', name: 'subject' },
    { tag: 'p', name: 'text' },
    { tag: 'p', name: 'html' }
  ]
}

export default {
  data () {
    return {
      updatedFields: { ...this.editObject },
      editing: false
    }
  },

  methods: {
    /**
     * Toggles editing mode
     * @param {Boolean} edit
     */
    toggleEditContent (edit) {
      this.editing = edit
    },

    /**
     * Updates content's part
     * @param {Object} e Updates value
     */
    updateContentField (e) {
      this.$set(this.updatedFields, e.input, e.value)
    },

    /**
     * Emits update event
     */
    updateContent () {
      this.toggleEditContent(false)
      this.$emit('updateContent', { content: this.updatedFields, meta: { id: this.id } })
    }
  },

  computed: {
    /**
     * Gives content's id if any
     * @returns {String|undefined}
     */
    id () {
      return this.editObject.id
    },

    /**
     * Tells what parts the given content can display
     * @returns {Array}
     */
    displayParts () {
      return TYPE_PART_DISPLAYS[this.contentType] || []
    },

    /**
     * Tells if content is being edited
     * @returns {Boolean}
     */
    isEditing () {
      return this.editing
    },

    /**
     * Gives content's parts to display
     * @returns {Object}
     */
    getEditedParts () {
      return this.updatedFields
    }
  },

  props: {
    editObject: {
      type: Object,
      required: true,
      default: () => { return {} }
    },

    contentType: {
      type: String,
      required: true
    }
  },

  watch: {
    editObject: {
      handler: function (newValue) {
        this.$set(this, 'updatedFields', { ...newValue })
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/service/administration/contentEditor.js